export const exercisesStats = {
  transcription: 'transcription',
  currentSet: 'currentSet',
  currentTimeLeft: 'currentTimeLeft',
  stopSend: 'stopSend',
  showReset: 'showReset',
  holdingCounter: 'holdingCounter',
  openSettingModel: 'openSettingModel',
  hideText: 'hideText',
  cameraIsActive: 'cameraIsActive',
  cameraCheckSettled: 'cameraCheckSettled',
  cameraReacquiring: 'cameraReacquiring',
  showPost: 'showPost',
  expireTime: 'expireTime',
  fullResetTime: 'fullResetTime',
  isCameraTranslated: 'isCameraTranslated',
  isCConfigure: 'isCConfigure',
  time: 'time',
  toggleMirror: 'toggleMirror',
  recordingDate: 'recordingDate',
  frontendFps: 'frontendFps',
  mediaSourceType: 'mediaSourceType',
  uploadedVideoUrl: 'uploadedVideoUrl',
  preStartCountdown: 'preStartCountdown',
  isPreStartCountdownComplete: 'isPreStartCountdownComplete',
  isRecordingActive: 'isRecordingActive',
  videoRotation: 'videoRotation',
  videoReady: 'videoReady',
  introResult: 'introResult',
  drawOnImage: 'drawOnImage',
  mediaPipeEnabled: 'mediaPipeEnabled',
  executionMode: 'executionMode',
};

export function exerciseReducer(state, action) {
  switch (action.type) {
    case exercisesStats.transcription:
      return { ...state, transcriptText: action.payload };
    case exercisesStats.currentSet:
      return { ...state, currentSet: action.payload };
    case exercisesStats.currentTimeLeft:
      return { ...state, currentTimeLeft: action.payload };
    case exercisesStats.stopSend:
      return { ...state, stopSend: action.payload };
    case exercisesStats.showReset:
      return { ...state, showReset: action.payload };
    case exercisesStats.holdingCounter:
      return { ...state, holdingCounter: action.payload };
    case exercisesStats.openSettingModel:
      return { ...state, openSettingModel: action.payload };
    case exercisesStats.hideText:
      return { ...state, hideText: action.payload };
    case exercisesStats.cameraIsActive:
      // Persisted so a reload can tell "camera was off when the page died" from
      // "camera was on" — the coarser cameraPermissionGranted flag only records
      // that permission was granted once, not the live device state.
      localStorage.setItem('cameraIsActive', String(Boolean(action.payload)));
      return { ...state, cameraIsActive: action.payload };
    case exercisesStats.cameraCheckSettled:
      // One-way latch: once getUserMedia has actually resolved or failed, the
      // real device state is known — never flips back to false afterwards.
      return state.cameraCheckSettled ? state : { ...state, cameraCheckSettled: action.payload };
    case exercisesStats.cameraReacquiring:
      // NOT a latch, unlike cameraCheckSettled above: a camera can die and come
      // back any number of times in one session, and the socket's open gate
      // (use-websocket-connection) reads this every time to avoid reopening
      // with a cameraAvailable that is only false because a reacquire — and
      // possibly a permission prompt — is still in flight.
      return { ...state, cameraReacquiring: action.payload };
    case exercisesStats.showPost:
      return { ...state, showPost: action.payload };
    case exercisesStats.expireTime:
      return { ...state, expireTime: action.payload };
    case exercisesStats.fullResetTime:
      return { ...state, fullResetTime: action.payload };
    case exercisesStats.isCameraTranslated:
      return { ...state, isCameraTranslated: action.payload };
    case exercisesStats.isCConfigure:
      return { ...state, isCConfigure: action.payload };
    case exercisesStats.time:
      return { ...state, time: action.payload };
    case exercisesStats.toggleMirror:
      return { ...state, toggleMirror: action.payload };
    case exercisesStats.recordingDate:
      return { ...state, recordingDate: action.payload };
    case exercisesStats.frontendFps:
      return { ...state, frontendFps: action.payload };
    case exercisesStats.mediaSourceType:
      return { ...state, mediaSourceType: action.payload };
    case exercisesStats.uploadedVideoUrl:
      return { ...state, uploadedVideoUrl: action.payload };
    case exercisesStats.preStartCountdown:
      return { ...state, preStartCountdown: action.payload };
    case exercisesStats.isPreStartCountdownComplete:
      return { ...state, isPreStartCountdownComplete: action.payload };
    case exercisesStats.isRecordingActive:
      return { ...state, isRecordingActive: action.payload };
    case exercisesStats.videoRotation:
      return { ...state, videoRotation: action.payload };
    case exercisesStats.videoReady:
      return { ...state, videoReady: action.payload };
    case exercisesStats.introResult:
      return { ...state, introResult: action.payload };
    case exercisesStats.drawOnImage:
      return { ...state, drawOnImage: action.payload };
    case exercisesStats.mediaPipeEnabled:
      return { ...state, mediaPipeEnabled: action.payload };
    case exercisesStats.executionMode:
      return { ...state, executionMode: action.payload };
    default:
      return state;
  }
}
